import { capitalCase } from "change-case";
import { Passenger } from "../../types/flights";
import { EDPassportDetails } from "./EDPassportDetails";
import enquiryscss from "../../../sass/enquiry-list/Enquiry.module.scss";

export const EDPassengersDetails: React.FC<{
  passengers: Passenger[] | undefined;
}> = (props) => {
  return (
    <>
      {props.passengers && props.passengers?.length > 0 && (
        <div className={enquiryscss.passenegerDetailsContainer}>
          <h6 className={enquiryscss.enquiryDetailHeading}>
            {" "}
            Passenger Details:{" "}
          </h6>
          {props.passengers.map((passenger, index) => {
            return (
              <div
                key={`passenger-${index}`}
                className={`${enquiryscss.sCrmPassengerItem} shadow-sm`}
              >
                <div className="row align-items-center">
                  <div className="col-lg-2 col-12">
                    <div
                      className={`${enquiryscss.passenger} passenger-${index}`}
                    >
                      Passenger
                      <span className={enquiryscss.bgPassengerNo}>
                        {" "}
                        {index + 1}
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className={enquiryscss.passengerSubItem}>
                      <span className={enquiryscss.passengerSubItemHeading}>
                        Type:
                      </span>{" "}
                      <span> {passenger.type} </span>
                    </div>
                  </div>
                  {/* <div className="col-lg-1 col-md-3 col-sm-6 col-6">
                    <div className={enquiryscss.passengerSubItem}>
                      <span className={enquiryscss.passengersubItemHeading}>
                        {" "}
                        Title:{" "}
                      </span>{" "}
                      <span> {passenger.title}</span>
                    </div>
                  </div> */}
                  <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className={enquiryscss.passengerSubItem}>
                      <span className={enquiryscss.passengerSubItemHeading}>
                        {" "}
                        Name:{" "}
                      </span>{" "}
                      <span>
                        {" "}
                        <b>{`${passenger.title}.`}</b>{" "}
                        {" " + capitalCase(passenger.firstName)}{" "}
                        {passenger.lastName}
                      </span>
                    </div>
                  </div>
                  {passenger.DOB && (
                    <div className="col-lg-2 col-md-3 col-sm-6 col-12">
                      <div className={enquiryscss.passengerSubItem}>
                        <span className={enquiryscss.passengerSubItemHeading}>
                          {" "}
                          Date of Birth :{" "}
                        </span>
                        <span> {passenger.DOB} </span>
                      </div>
                    </div>
                  )}
                </div>
                {passenger.passportNumber && (
                  <div className="passport-details">
                    <EDPassportDetails passport={passenger} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
